import { keepPreviousData, useQuery } from "@tanstack/react-query";
import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";
import { Tabs, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { AUDIT_CATEGORIES, type AuditCategory } from "@/features/admin/labels";
import { AuditList, PageHeader } from "@/features/admin/parts";
import { auditQuery } from "@/lib/api/queries";

const CATEGORY_IDS = AUDIT_CATEGORIES.map((c) => c.id) as [AuditCategory, ...AuditCategory[]];

export const Route = createFileRoute("/_app/admin/audit")({
  validateSearch: z.object({ category: z.enum(CATEGORY_IDS).optional() }),
  loaderDeps: ({ search }) => ({ category: search.category ?? "activity" }),
  loader: ({ context, deps }) =>
    context.queryClient.ensureQueryData(auditQuery(categoryActions(deps.category))),
  component: AuditPage,
});

function categoryActions(id: AuditCategory) {
  return AUDIT_CATEGORIES.find((c) => c.id === id)?.actions ?? null;
}

function AuditPage() {
  const category = Route.useSearch().category ?? "activity";
  const navigate = Route.useNavigate();
  const { data } = useQuery({
    ...auditQuery(categoryActions(category)),
    placeholderData: keepPreviousData,
  });

  return (
    <>
      <PageHeader title="Журнал" />
      <p className="mt-2 text-sm text-muted">
        Последние 200 событий. Подключения устройств хранятся 90 дней.
      </p>
      <Tabs
        className="mt-6"
        value={category}
        onValueChange={(value) =>
          navigate({ search: { category: value as AuditCategory }, replace: true })
        }
      >
        <TabsList aria-label="Какие события показать">
          {AUDIT_CATEGORIES.map((c) => (
            <TabsTrigger key={c.id} value={c.id}>
              {c.label}
            </TabsTrigger>
          ))}
        </TabsList>
      </Tabs>
      <div className="mt-4">
        <AuditList entries={data ?? []} />
      </div>
    </>
  );
}
